import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_ROOT } from '@shared/constants/api-root.const';
import { AUTH_HEADER_NAME } from '@shared/constants/auth-name.const';
import { CookieService } from '@shared/services/cookie.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  private _API_ROOT = inject(API_ROOT);
  private _cookieService = inject(CookieService);

  private _authCookieName = environment.authCookieName;
  private defaultUpdateOptions = { withCredentials: true };

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const userToken = this._cookieService.getCookie(this._authCookieName);

    if (req.url.includes(this._API_ROOT, 0) && userToken) {

      return next.handle(req.clone({
        ...this.defaultUpdateOptions,
      }));
    }
    return next.handle(req.clone({ ...this.defaultUpdateOptions }));
  }
}
